















import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import DepartmentType from '@/modules/reservation/model/DepartmenType';
import {State} from 'vuex-class';
import {notify} from '@/modules/core/notification';

@Component
export default class ConfirmDepartmentTypeDelete extends Vue {
    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({ type: Boolean, default: false })
    public value: boolean

    @State(state => state.reservation.currentDepartmentType)
    public type: DepartmentType

    public deleting = false

    /**
     * Elimina el tipo de departamento actual
     */
    public async remove () {
        this.deleting = true
        const { name } = this.type
        await this.$store.dispatch('reservation/deleteDepartmentType')

        this.deleting = false
        this.$emit('input', false)

        notify(`El tipo de departamento ${name} ha sido eliminado`)
    }

    public errorCaptured () {
        this.deleting = false
        this.$emit('input', false)
    }
}
